import React from "react";

import { Container } from "./styles";

type Props = {
  isMenuOpen: boolean;
  setOpen: (prop: boolean) => void;
};

export default function Burger({ isMenuOpen, setOpen }: Props) {
  return (
    <Container data-testid="burger" openMenu={isMenuOpen} onClick={() => setOpen(!isMenuOpen)}>
      {/* Each div is a line at the burger icon. */}
      <div></div>
      <div></div>
      <div></div>
    </Container>
  );
}
